module.exports = __webpack_public_path__ + "static/media/bag.480591c1.svg";